import styled from 'styled-components';

export const Wrapper = styled.fieldset`
    display: flex;
    flex-direction: column;
    border: none;
    margin: 0;
    padding: 0;
`;
